import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FormikErrors, FormikValues } from "formik";
import { proceedToNextFormStep } from "../../../../actions/diversityFormActions";
import { Button, DisabledButton } from "../../styles/diversity-form-styles";

export interface INextButtonProps {
  ethnicGroup?: string;
  ethnicSubgroup?: string;
  errors?: FormikErrors<FormikValues>;
  proceedToNextFormStepAction: typeof proceedToNextFormStep;
}

export const NextButton: FunctionComponent<INextButtonProps> = ({
  ethnicGroup,
  ethnicSubgroup,
  errors,
  proceedToNextFormStepAction,
}) => {
  if (
    (ethnicGroup === "Arab" || ethnicGroup === "Prefer not to say") &&
    !errors.ethnicGroup &&
    !errors.ethnicSubgroup
  ) {
    return (
      <Button
        type="button"
        onClick={proceedToNextFormStepAction}
        data-test-id="next-button"
      >
        Next
      </Button>
    );
  }
  if (
    (ethnicGroup === "Asian" ||
      ethnicGroup === "Black" ||
      ethnicGroup === "Mixed" ||
      ethnicGroup === "White") &&
    ethnicSubgroup &&
    !errors.ethnicGroup &&
    !errors.ethnicSubgroup
  ) {
    return (
      <Button
        type="button"
        onClick={proceedToNextFormStepAction}
        data-test-id="next-button"
      >
        Next
      </Button>
    );
  }
  if (
    ethnicGroup === "Other" &&
    !errors.ethnicGroup &&
    !errors.ethnicSubgroup &&
    ethnicSubgroup
  ) {
    return (
      <Button
        type="button"
        onClick={proceedToNextFormStepAction}
        data-test-id="next-button"
      >
        Next
      </Button>
    );
  }
  return <DisabledButton type="button">Next</DisabledButton>;
};

NextButton.propTypes = {
  ethnicGroup: PropTypes.string,
  ethnicSubgroup: PropTypes.string,
  errors: PropTypes.shape({
    ethnicGroup: PropTypes.string,
    ethnicSubgroup: PropTypes.string,
  }),
  proceedToNextFormStepAction: PropTypes.func.isRequired,
};

NextButton.defaultProps = {
  errors: null,
  ethnicGroup: null,
  ethnicSubgroup: null,
};

export default connect(null, {
  proceedToNextFormStepAction: proceedToNextFormStep,
})(NextButton);
